<template>
  <div>
    <app-cells>
      <app-textarea
        v-model="snack_bar_info.notes"
        rows="5"
        @change.native="onChangeStatus({notes: snack_bar_info.notes})"
        placeholder="Notes"
        :readonly="!is_safari_supervisor && !is_sales_general_manager"
      />
    </app-cells>
    <div class="downloads">
      <div class="downloads__item" :class="{'downloads__item--loading': loaders.orders}">
        <div class="downloads__left">
          <div class="downloads__info">
            <span class="downloads__name downloads__name--no-events">Orders available</span>
          </div>
        </div>
        <div class="downloads__right">
          <div class="downloads__values">
            <span class="downloads__key">Status:</span>
            <app-switcher
              :readonly="!is_safari_supervisor"
              v-model="snack_bar_info.orders_available"
              @change="onChangeStatus({orders_available: snack_bar_info.orders_available}, 'orders')"
            />
          </div>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': loaders.summary}">
        <div class="downloads__left">
          <img :src="require(`@/assets/img/downloads-pdf.svg`)" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadSummary" class="downloads__name">Snack bar summary</button>
          </div>
        </div>
        <div class="downloads__right">
          <div class="downloads__values">
            <span class="downloads__key">Printed:</span>
            <app-switcher
              v-model="snack_bar_info.summary_printed"
              @change="onChangeStatus({summary_printed: snack_bar_info.summary_printed}, 'summary')"
              :readonly="!is_safari_all"
            />
          </div>
          <template v-if="snack_bar_info.summary_printed && !loaders.summary">
            <div class="downloads__values">
              <span class="downloads__key">Printed at:</span>
              <span class="downloads__value downloads__width">{{ dateTimeFormat(snack_bar_info.summary_printed_at) }}</span>
            </div>
            <div class="downloads__values">
              <span class="downloads__key">Printed by:</span>
              <div class="downloads__person downloads__width">
                <div class="downloads__photo">
                  <img :src="getUserAvatar(snack_bar_info.summary_printed_by?.crop.crop_url)" alt="Person">
                </div>
                <span class="downloads__value">{{ snack_bar_info.summary_printed_by?.full_name || '-' }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': loaders.packing}">
        <div class="downloads__left">
          <div class="downloads__info">
            <span class="downloads__name downloads__name--no-events">Packing started</span>
          </div>
        </div>
        <div class="downloads__right">
          <div class="downloads__values">
            <span class="downloads__key">Status:</span>
            <app-switcher
              v-model="snack_bar_info.packing_started"
              @change="onChangeStatus({packing_started: snack_bar_info.packing_started}, 'packing')"
              :readonly="!is_safari_all"
            />
          </div>
          <template v-if="snack_bar_info.packing_started && !loaders.packing">
            <div class="downloads__values">
              <span class="downloads__key">Started at:</span>
              <span class="downloads__value downloads__width">{{ dateTimeFormat(snack_bar_info.packing_started_at) }}</span>
            </div>
            <div class="downloads__values">
              <span class="downloads__key">Started by:</span>
              <div class="downloads__person downloads__width">
                <div class="downloads__photo">
                  <img :src="getUserAvatar(snack_bar_info.packing_started_by?.crop.crop_url)" alt="Person">
                </div>
                <span class="downloads__value">{{ snack_bar_info.packing_started_by?.full_name || '-' }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <app-cells>
        <h2 class="title">To be collected</h2>
      </app-cells>
      <app-cells>
        <h3 class="title">Basic</h3>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card info-cards__card--nominh">
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Drinking water:</span> <span>{{ groupDetail.snack_bar.water_count }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Soda (Mixed):</span> <span>{{ groupDetail.snack_bar.soda_count }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card info-cards__card--nominh">
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Wet wipes (Big):</span><span>{{ groupDetail.snack_bar.wet_wipes_count }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Safari bottles:</span> <span>{{ groupDetail.snack_bar.safari_bottles_count }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card info-cards__card--nominh">
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Kid toys:</span> <span>{{ groupDetail.snack_bar.kid_toys_count }}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="table_collect.items.length">
        <app-cells>
          <h3 class="title">Additional orders</h3>
        </app-cells>
        <v-client-table
          :data="table_collect.items"
          :columns="table_collect.columns"
          :options="table_collect.options"
          class="table-default table-default--indent"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__client>
            <div class="table-default__left">Client</div>
          </template>
          <template #client="{ row }">
            <div class="table-default__left table-default__controls">
              <a
                v-if="is_sales_general_manager"
                :href="`${family_url}${row.client.hash}/snacks/${row.hash}`"
                target="_blank"
                class="table-default__snacks-link"
              ></a>
              {{ row.client.full_name }}
            </div>
          </template>
          <template #collected="{ row, index }">
            <label class="checkbox checkbox--table">
              <input
                v-model="row.snack_bar.collected"
                type="checkbox"
                :name="`collected_${index}`"
                @change="updateTableData(row.id, { snack_bar_collected: row.snack_bar.collected })"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #order="{ row }">
            {{ row.snack_bar.order_amount.toLocaleString() }}$
          </template>
          <template #credit="{ row }">
            {{ row.snack_bar.credit.toLocaleString() }}$
          </template>
          <template #outstanding="{ row }">
            {{ row.snack_bar.outstanding_amount.toLocaleString() }}$
          </template>
        </v-client-table>
      </template>
      <div class="downloads__item" :class="{'downloads__item--loading': loaders.collected}">
        <div class="downloads__left">
          <div class="downloads__info">
            <span class="downloads__name downloads__name--no-events">Collected</span>
          </div>
        </div>
        <div class="downloads__right">
          <div class="downloads__values">
            <span class="downloads__key">Status:</span>
            <app-switcher
              v-model="snack_bar_info.collected"
              @change="onChangeStatus({collected: snack_bar_info.collected}, 'collected')"
              :readonly="!is_safari_all"
            />
          </div>
          <template v-if="snack_bar_info.collected && !loaders.collected">
            <div class="downloads__values">
              <span class="downloads__key">Collected at:</span>
              <span class="downloads__value downloads__width">{{ dateTimeFormat(snack_bar_info.collected_at) }}</span>
            </div>
            <div class="downloads__values">
              <span class="downloads__key">Collected by:</span>
              <div class="downloads__person downloads__width">
                <div class="downloads__photo">
                  <img :src="getUserAvatar(snack_bar_info.collected_by?.crop.crop_url)" alt="Person">
                </div>
                <span class="downloads__value">{{ snack_bar_info.collected_by?.full_name || '-' }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': loaders.passed}">
        <div class="downloads__left">
          <div class="downloads__info">
            <span class="downloads__name downloads__name--no-events">Passed to driver</span>
          </div>
        </div>
        <div class="downloads__right">
          <div class="downloads__values">
            <span class="downloads__key">Status:</span>
            <app-switcher
              v-model="snack_bar_info.passed_to_driver"
              @change="onChangeStatus({passed_to_driver: snack_bar_info.passed_to_driver}, 'passed')"
              :readonly="!is_safari_all"
            />
          </div>
          <template v-if="snack_bar_info.passed_to_driver && !loaders.passed">
            <div class="downloads__values">
              <span class="downloads__key">Passed at:</span>
              <span class="downloads__value downloads__width">{{ dateTimeFormat(snack_bar_info.passed_to_driver_at) }}</span>
            </div>
            <div class="downloads__values">
              <span class="downloads__key">Passed by:</span>
              <div class="downloads__person downloads__width">
                <div class="downloads__photo">
                  <img :src="getUserAvatar(snack_bar_info.passed_to_driver_by?.crop.crop_url)" alt="Person">
                </div>
                <span class="downloads__value">{{ snack_bar_info.passed_to_driver_by?.full_name || '-' }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="table_payment.items.length">
      <app-cells>
        <h2 class="title">Unpaid</h2>
      </app-cells>
      <v-client-table
          :data="table_payment.items"
          :columns="table_payment.columns"
          :options="table_payment.options"
          class="table-default"
      >
        <template #h__client>
          <div class="table-default__left">Client</div>
        </template>
        <template #client="{ row }">
          <div class="table-default__left table-default__controls">
            <a
              v-if="is_sales_general_manager"
              :href="`${family_url}${row.client.hash}/snacks/${row.hash}`"
              target="_blank"
              class="table-default__snacks-link"
            ></a>
            {{ row.client.full_name }}
          </div>
        </template>
        <template #order="{ row }">
          {{ row.snack_bar.order_amount.toLocaleString() }}$
        </template>
        <template #credit="{ row }">
          {{ row.snack_bar.credit.toLocaleString() }}$
        </template>
        <template #outstanding="{ row }">
          {{ row.snack_bar.outstanding_amount.toLocaleString() }}$
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import {
  getSafariGroupSnackBarExport,
  getSafariGroupsSnackBarInfo,
  getSafariGroupsSnacksList,
  getSafariSnackBarRequestPrint,
  patchSafariGroupsSnackBarInfo,
  patchSafariSnackBarRequests,
} from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'SafariGroupsDetailSnacks',
  props: {
    groupDetail: { Object }
  },
  data() {
    return {
      table_preloader: false,
      table_collect: {
        items: [],
        columns: ['client', 'order', 'credit', 'outstanding'],
        options: {
          headings: {
            client: 'Client',
            collected: 'Collected',
            order: 'Order amount',
            credit: 'Credit',
            outstanding: 'Outstanding amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_payment: {
        items: [],
        columns: ['client', 'order', 'credit', 'outstanding'],
        options: {
          headings: {
            client: 'Client',
            order: 'Order amount',
            credit: 'Credit',
            outstanding: 'Outstanding amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      family_url: process.env.VUE_APP_FAMILY,
      print_preload: null,
      snack_bar_info: {},
      loaders: {
        orders: false,
        packing: false,
        passed: false,
        summary: false,
        collected: false,
      },
    }
  },
  computed: {
    is_sales_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager') || this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_general_operations_manager() {
      return this.is_sales_general_manager || this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
    is_safari_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('safari_supervisor')
    },
    is_safari_all() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('safari_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('safari_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('safari_assistant')
    }
  },
  created() {
    getSafariGroupsSnackBarInfo(this.$route.params.id)
      .then(response => {
        this.snack_bar_info = response.data
      })
    this.fetchItems()
  },
  methods: {
    onChangeStatus(data, field) {
      if (field) this.loaders[field] = true
      patchSafariGroupsSnackBarInfo(this.$route.params.id, data)
        .then(response => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
          this.snack_bar_info = response.data
        })
        .finally(() => {
          if (field) this.loaders[field] = false
        })
    },
    onDownloadSummary() {
      this.loaders.summary = true
      getSafariGroupSnackBarExport(this.$route.params.id)
        .then(response => {
          this.loaders.summary = false
          window.open(response.data)
        })
        .catch(() => {
          this.loaders.summary = false
        })
    },
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    fetchItems() {
      getSafariGroupsSnacksList(this.$route.params.id, { snack_bar: 'need_to_collect' }).then(res => {
        this.table_collect.items = res.data
        if (this.is_safari_all) this.table_collect.columns.splice(1, 0, 'collected')
      })
      getSafariGroupsSnacksList(this.$route.params.id, { snack_bar: 'need_payment' }).then(res => {
        this.table_payment.items = res.data
      })
    },
    onPrint(row) {
      this.print_preload = `print_${row.id}`
      getSafariSnackBarRequestPrint(row.id)
        .finally(() => { this.print_preload = null })
        .then(response => { window.open(response.data) })
    },
    updateTableData(id, data) {
      this.table_preloader = true
      patchSafariSnackBarRequests(id, this.$route.params.id, data)
        .finally(() => {
          getSafariGroupsSnacksList(this.$route.params.id, { snack_bar: 'need_to_collect' }).then(res => {
            this.table_collect.items = res.data
            this.table_preloader = false
          })
        })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
        })
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
